import { type StateCreator } from 'zustand';

const RESEND_COOLDOWN_MS = 60_000;

export type PendingEmailCooldownSlice = {
  endsAt: number;
  start: () => void;
  clear: () => void;
};

export const createPendingEmailCooldownSlice: StateCreator<
  PendingEmailCooldownSlice,
  [],
  [],
  PendingEmailCooldownSlice
> = (set) => ({
  endsAt: 0,
  start: () => set({ endsAt: Date.now() + RESEND_COOLDOWN_MS }),
  clear: () => set({ endsAt: 0 }),
});
